import React, { useState, useEffect, useRef, Fragment } from "react";
import * as _ from "lodash";
import "../../Invs/AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead, WaterMarkName } from "../../Invs/ShareFunctionsPrint";
import HeaderAll from "../../HeaderAll";
import ReceiptBodyS from "./ReceiptBodyS";
import BodyVochar from "./BodyVochar";
import HeaderSand from "../Kharji/Casher/HeaderSand";
import BodySand from "../Kharji/Casher/BodySand";
import FooterSand from "../Kharji/Casher/FooterSand";
import { Grid, Typography } from "@material-ui/core";

function HeadersNew(props) {
    const { found } = props;
    return (
        <div style={stylePaddingHead}>
            <HeaderAll Report={false} found={found} />
        </div>
    );
}
function BodyPrint(props) {
    const { infoData } = props;
    return (
        <div style={stylePadding}>
            {infoData?.temp == 1 ? <ReceiptBodyS infoData={infoData} /> : <BodyVochar infoData={infoData} />}
        </div>
    );
}
function SanadsPrintCon(props) {
    const { info, dataAccounts ,sta, onUnmountComplete} = props;
    return (
        <>{dataAccounts.isLarge ?
            <div className="invoicepreview">
                <div className="pageinv" >
                    <WaterMarkName found={info} />
                    <div className="contentview">
                        <HeadersNew found={info} infoData={dataAccounts} />
                        <BodyPrint infoData={dataAccounts} />
                    </div>
                </div>
            </div> :
            <Typography component="div" >
                <Grid item >
                    <Fragment>
                        <HeaderSand info={info} onUnmountComplete={onUnmountComplete} />
                        <BodySand sta={sta}
                            locinf={dataAccounts}
                            onUnmountComplete={onUnmountComplete}
                        />
                        <FooterSand found={info} onUnmountComplete={onUnmountComplete} />

                    </Fragment>
                </Grid>
            </Typography>
        }

        </>
    );
}
export default SanadsPrintCon;
